export default [
  {
    path: 'at',
    name: 'at',
    component: () => import('@/views/at/Wrapper'),
    children: [
      {
        path: '',
        name: 'at',
        component: () => import('@/views/at/Menu.vue'),
        children: [],
      },
      {
        path: 'referralsandequipment',
        name: 'referralsandequipment',
        component: () => import('@/views/at/referralAndEquipment/Main.vue'),
      },
      {
        path: 'referralsandequipment/referral/:id/evaluationreport',
        name: 'ReferralEvaluationReport',
        component: () =>
          import(
            '@/views/at/referralAndEquipment/referralEvaluationReport/Main.vue'
          ),
      },
      {
        path: 'referralsandequipment/referral/:id/:type',
        name: 'ReferralDetails',
        component: () =>
          import('@/views/at/referralAndEquipment/referralDetails/Main.vue'),
      },
      {
        path: 'referralsandequipment/equipment/:id/requisitionanalysis',
        name: 'RequisitionAnalysis',
        component: () =>
          import(
            '@/views/at/referralAndEquipment/requisitionAnalysis/Main.vue'
          ),
      },
      {
        path:
          'referralsandequipment/equipment/requisitionanalysis/:id/:recommendationId/availabilitymanagement',
        name: 'AvailabilityManagement',
        component: () =>
          import(
            '@/views/at/referralAndEquipment/availabilityManagement/Main.vue'
          ),
      },
      {
        path: 'calendar',
        name: 'Calendar',
        component: () => import('@/views/at/calendar/Main.vue'),
      },
      {
        path: 'requisitionmanagement',
        name: 'RequisitionManagement',
        component: () => import('@/views/at/requisitionManagement/Main.vue'),
      },
      {
        path: 'requisitionmanagement/:peiAtServiceId',
        name: 'RequisitionManagementDetail',
        component: () =>
          import(
            '@/views/at/requisitionManagement/components/RequisitionDetail.vue'
          ),
      },
      {
        path: 'digitizedfile',
        name: 'DigitizedFile',
        component: () => import('@/views/at/digitizedFile/Main.vue'),
      },
    ],
  },
];
